import React from 'react'

import './LogoStyles.less'

export default () => (
  <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M198.332 165.178C201.043 165.767 203.626 163.518 204.102 160.151C204.607 161.046 205.113 161.943 205.619 162.841C205.144 166.208 202.559 168.457 199.851 167.868C199.346 166.97 198.839 166.074 198.332 165.178Z"
      fill="#FADB14"
    />
    <path
      d="M118.264 237.216C120.975 237.805 123.558 235.555 124.033 232.188C124.539 233.084 125.045 233.981 125.55 234.878C125.076 238.245 122.491 240.496 119.783 239.906C119.277 239.008 118.771 238.111 118.264 237.216Z"
      fill="#5EEB9D"
    />
    <path
      d="M204.387 108.807C205.524 111.919 208.475 113.302 210.983 111.889C210.673 112.915 210.362 113.94 210.05 114.965C207.542 116.375 204.591 114.994 203.455 111.88C203.767 110.857 204.078 109.832 204.387 108.807Z"
      fill="#8743AA"
    />
    <path
      d="M186.842 86.7004C187.3 83.3288 185.471 80.1365 182.757 79.5686C183.475 78.9332 184.193 78.2981 184.912 77.6631C187.625 78.231 189.454 81.4247 188.998 84.7949C188.28 85.4304 187.561 86.0655 186.842 86.7004Z"
      fill="#00678A"
    />
    <path
      d="M23.9193 73.0939C24.3769 69.7224 22.5485 66.5299 19.834 65.962C20.5518 65.3266 21.2703 64.6915 21.9895 64.0566C24.7019 64.6245 26.5314 67.8181 26.0748 71.1884C25.357 71.8238 24.6385 72.4589 23.9193 73.0939Z"
      fill="#8743AA"
    />
    <path
      d="M79.4373 192.558C79.895 189.186 78.0665 185.994 75.3521 185.426C76.0699 184.79 76.7883 184.155 77.5075 183.52C80.2199 184.088 82.0493 187.282 81.5928 190.653C80.875 191.287 80.1565 191.923 79.4373 192.558Z"
      fill="#8743AA"
    />
    <path
      d="M221.838 66.215C224.531 66.9199 227.173 64.7795 227.74 61.4326C228.222 62.3496 228.703 63.2673 229.185 64.1857C228.619 67.5293 225.975 69.6709 223.284 68.9681C222.801 68.0511 222.319 67.1334 221.838 66.215Z"
      fill="#FADB14"
    />
    <path
      d="M6.41364 107.632C5.44827 104.43 2.57761 102.806 0 104.007C0.364622 103.011 0.729781 102.014 1.09548 101.016C3.67095 99.8169 6.54321 101.439 7.50912 104.64C7.14451 105.637 6.77935 106.634 6.41364 107.632Z"
      fill="#FADB14"
    />
    <path
      d="M73.3102 146.635C73.5004 150.045 75.8805 152.617 78.6252 152.38C78.0464 153.208 77.4665 154.032 76.8888 154.86C74.143 155.095 71.7638 152.521 71.5737 149.112C72.1526 148.287 72.7314 147.462 73.3102 146.635Z"
      fill="#11D175"
    />
    <path
      d="M53.9126 84.6814C56.6386 84.2116 58.5412 81.0846 58.1619 77.6982C58.8661 78.3595 59.5693 79.0199 60.2715 79.6796C60.6497 83.0673 58.7481 86.1923 56.0221 86.6641C55.3199 86.0027 54.6168 85.3419 53.9126 84.6814Z"
      fill="#00678A"
    />
    <path
      d="M165.07 43.1556C161.536 43.2769 164.077 49.7351 160.541 49.8591C159.866 49.1549 159.191 48.4507 158.515 47.7466C162.051 47.6245 159.51 41.1664 163.044 41.0425C163.72 41.7466 164.396 42.451 165.07 43.1556Z"
      fill="#8743AA"
    />
    <path
      d="M171.494 212.898C168.053 211.885 169.168 218.938 165.727 217.927C165.22 217.03 164.714 216.133 164.208 215.237C167.649 216.249 166.533 209.196 169.976 210.208C170.482 211.105 170.988 212.001 171.494 212.898Z"
      fill="#FADB14"
    />
    <path
      d="M69.1746 222.08C66.7444 225.273 72.2172 227.612 69.7869 230.803C68.9093 230.896 68.0305 230.993 67.1529 231.086C69.5832 227.895 64.1103 225.559 66.5406 222.366C67.4193 222.272 68.2973 222.177 69.1746 222.08Z"
      fill="#00678A"
    />
    <path
      d="M147.896 1.62443C144.436 2.53753 147.87 8.32411 144.412 9.23524C143.647 8.69268 142.878 8.15211 142.113 7.60823C145.573 6.69763 142.136 0.913143 145.597 0C146.364 0.543868 147.13 1.08535 147.896 1.62443Z"
      fill="#11D175"
    />
    <path
      d="M36.85 20.6465C38.552 24.4989 42.0213 18.7449 43.7207 22.5961C43.5233 23.6623 43.3284 24.7325 43.1299 25.7994C41.4305 21.947 37.9632 27.7029 36.2612 23.8505C36.4592 22.781 36.6554 21.7129 36.85 20.6465Z"
      fill="#5EEB9D"
    />
    <path
      d="M7.50928 172.116C7.96581 172.031 8.37883 171.781 8.67625 171.412C8.97368 171.042 9.13661 170.576 9.13661 170.095C9.13661 169.613 8.97368 169.147 8.67625 168.778C8.37883 168.408 7.96581 168.159 7.50928 168.073"
      fill="#12B1D6"
    />
    <path
      d="M192.216 15.9184C190.729 15.9184 189.519 14.4153 189.519 12.5675C189.519 10.7198 190.729 9.2168 192.216 9.2168C193.704 9.2168 194.913 10.7199 194.913 12.5676C194.913 14.4153 193.704 15.9184 192.216 15.9184ZM192.216 10.5459C191.744 10.5944 191.309 10.8334 191.004 11.2115C190.7 11.5896 190.551 12.0765 190.589 12.5676C190.546 12.8148 190.556 13.0688 190.617 13.3117C190.679 13.5546 190.792 13.7805 190.947 13.9733C191.102 14.1661 191.296 14.3212 191.516 14.4277C191.735 14.5341 191.974 14.5893 192.216 14.5893C192.458 14.5893 192.698 14.5341 192.917 14.4277C193.136 14.3212 193.33 14.1661 193.485 13.9733C193.641 13.7805 193.753 13.5546 193.815 13.3117C193.877 13.0688 193.887 12.8148 193.844 12.5676C193.882 12.0765 193.733 11.5896 193.428 11.2115C193.124 10.8334 192.689 10.5944 192.216 10.5459Z"
      fill="#12B1D6"
    />
    <path
      d="M35.2021 142.868C33.7148 142.868 32.5049 141.365 32.5049 139.517C32.5049 137.67 33.7148 136.167 35.2021 136.167C36.6893 136.167 37.8993 137.67 37.8993 139.517C37.8993 141.365 36.6894 142.868 35.2021 142.868ZM35.2021 137.496C34.7456 137.582 34.3325 137.831 34.0351 138.2C33.7377 138.57 33.5748 139.036 33.5748 139.517C33.5748 139.999 33.7377 140.465 34.0351 140.835C34.3325 141.204 34.7456 141.453 35.2021 141.539C35.6586 141.453 36.0716 141.204 36.3691 140.835C36.6665 140.465 36.8294 139.999 36.8294 139.517C36.8294 139.036 36.6665 138.57 36.3691 138.2C36.0716 137.831 35.6586 137.582 35.2021 137.496Z"
      fill="#12B1D6"
    />
    <path
      d="M238.904 176.176C237.939 172.974 235.068 171.35 232.491 172.551C232.855 171.555 233.221 170.559 233.586 169.56C236.162 168.361 239.034 169.984 240 173.184C239.635 174.181 239.27 175.179 238.904 176.176Z"
      fill="#12B1D6"
    />
    <path
      d="M153.333 120C153.333 138.41 138.409 153.333 120 153.333C101.59 153.333 86.6665 138.41 86.6665 120C86.6665 101.591 101.59 86.6667 120 86.6667C138.409 86.6667 153.333 101.591 153.333 120ZM116.144 137.65L140.875 112.919C141.715 112.079 141.715 110.717 140.875 109.877L137.834 106.836C136.994 105.996 135.633 105.996 134.793 106.836L114.623 127.005L105.207 117.589C104.367 116.749 103.005 116.749 102.166 117.589L99.1243 120.63C98.2845 121.47 98.2845 122.831 99.1243 123.671L113.103 137.65C113.943 138.49 115.304 138.49 116.144 137.65Z"
      fill="#11D175"
    />
  </svg>
)
